import "./index.css";
import { useTranslation } from "react-i18next";

const CompanyIntroDesc = () => {
  const { t } = useTranslation();
  return (
    <div className="company-intro-desc">
      <h5>{t("COMPANY")}</h5>
      <p style={{ marginBottom: "10px" }}>{t("COMPANY_INTRO_DESC_1")}</p>
      <p>{t("COMPANY_INTRO_DESC_2")}</p>
    </div>
  );
};

export default CompanyIntroDesc;
